import { render, staticRenderFns } from "./socialResponsibility.vue?vue&type=template&id=c5b846ea&"
import script from "./socialResponsibility.vue?vue&type=script&lang=js&"
export * from "./socialResponsibility.vue?vue&type=script&lang=js&"
import style0 from "./socialResponsibility.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports